import { useContext, createContext } from "react";
const FieldPropsContext = createContext(
  void 0
);
function useFieldProps() {
  const context = useContext(FieldPropsContext);
  if (typeof context === "undefined") {
    throw new Error("useFieldProps must be used within a FieldPropsProvider");
  }
  return context;
}
function useFieldPropsV2() {
  return useFieldProps().v2;
}
export {
  FieldPropsContext,
  useFieldProps,
  useFieldPropsV2
};
//# sourceMappingURL=field-props-context.js.map
